module.exports = __webpack_public_path__ + "assets/98c340a6ec65f579685b405c67130dc3.mp3";